













import Vue                      from 'vue'
import {Component, Prop, Model} from 'vue-property-decorator'
import {Dictionary}             from '@/types'
import {prop, resolve}          from '@/common/helpers'

@Component
export default class CustomSelect extends Vue {
    @Prop(String)
    private label!: string

    @Model('change', [String, Number])
    private value!: string | number

    @Prop(String)
    private placeholder!: string

    @Prop(prop(Array as () => Dictionary[], []))
    private options!: Dictionary[]

    @Prop(prop(String, 'label'))
    private labelIndex!: string

    @Prop(prop(String, 'value'))
    private valueIndex!: string

    protected get mappedOptions() {
        const {options, labelIndex, valueIndex} = this
        return options.map((option) => {
            const label = resolve(option, labelIndex)
            const value = resolve(option, valueIndex)
            return {key: value, label, value}
        })
    }
}
